import styles from './DropdownAddress.module.scss';
import { CountryDropdown as Dropdown } from '../../../../../commons/hoc';
import { ThreeLineAddress } from '../../../../global';
import { useEffect, useState } from 'react';
import { convertAPIAddressToRedux } from '../../../../../commons/utils/utils';

const DropdownAddress = ({
  type = 'shipping',
  ddOptions = [],
  disabledId = '',
  rdxUpdateAddressCB = () => {},
  onChangeCB = () => {},
  addNewCB = () => {},
  showSelectedAddress = true,
  ...rest
}) => {
  const [selectedAddress, setSelectedAddress] = useState(null);

  useEffect(() => {
    if (rest?.defaultValue)
      onAddressChange({ target: { value: rest.defaultValue } });
  }, [ddOptions]);

  const onAddressChange = (e) => {
    let value = e.target.value;
    let address = null;
    onChangeCB(value);
    if (value == 'ADD_NEW_OPTION') {
      addNewCB(e);
    } else {
      address = ddOptions.find((item) => item.id == value)?.data;
      if (!address?.id) address = null;
      else address = convertAPIAddressToRedux(address);
    }
    setSelectedAddress(address);
  };

  return (
    <div>
      <>
        <div className={`${styles.dropDownContainer}`}>
          <Dropdown
            options={ddOptions}
            name={`${type}-address`}
            tkey="title"
            id={`${type}-address-dd`}
            addNewOption={true}
            addNewText={`Add new ${type} address`}
            optionsOrder={[3, 2]}
            disabledItem={disabledId}
            onChange={onAddressChange}
            {...rest}
          />
        </div>
      </>
      {selectedAddress && showSelectedAddress && (
        <div className={styles.formattedAddressDisplay}>
          <ThreeLineAddress address={selectedAddress} rebrand={true} />
        </div>
      )}
    </div>
  );
};

export default DropdownAddress;
